<template>
  <div
    class="col-5"
    v-if="objects"
    v-loading="loading"
  >
    <div class="b-map-sidebar">
      <div class="b-map-sidebar-container">
        <div>
          <div class="row b-map-sidebar-label">
            <div class="col-6">Объект</div>
            <div
              class="col-6"
              style="text-align: right; cursor: pointer;"
              @click="selectAllObjects"
            >
              Выбрать все объекты
            </div>
          </div>
          <el-select
            class="b-single-select"
            v-model="selectedObjects"
            placeholder="Выберите объект"
            @change="selectObject"
            multiple
          >
            <el-option
              v-for="(item, index) in objects"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <div>
          <div class="b-map-sidebar-label">Тип карты</div>
          <el-select
            class="b-single-select"
            v-model="selectedMapType"
            @change="changeMapType"
          >
            <el-option
              v-for="(value, key) in mapTypes"
              :key="value"
              :label="value"
              :value="key"
            />
          </el-select>
        </div>
        <div class="b-datepicker-container">
          <div class="b-map-sidebar-label">
            {{ isSecondDateRequired ? 'Выберите период' : 'Выберите месяц и год' }}
          </div>
          <div class="row">
            <div class="col-6">
              <el-date-picker
                v-model="selectedDateFrom"
                type="month"
                format="MM-YYYY"
                value-format="YYYY-MM"
              />
            </div>
            <div class="col-6">
              <el-date-picker
                v-model="selectedDateTo"
                v-if="isSecondDateRequired"
                type="month"
                format="MM-YYYY"
                value-format="YYYY-MM"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="b-map-sidebar">
      <div>
        <div class="b-map-sidebar-label b-label-bold">Масштаб карты</div>
        <hr class="my-0">
      </div>
      <div class="b-map-sidebar-container">
        <div>
          <el-select
            class="b-single-select"
            v-model="selectedMapScale"
          >
            <el-option
              v-for="(value, key) in mapScales"
              :key="value"
              :label="key"
              :value="value"
            />
          </el-select>
        </div>
      </div>
    </div>
    <div
      class="b-map-sidebar"
      v-if="isWidthScaleRequired"
    >
      <div>
        <div class="b-map-sidebar-label b-label-bold">Параметры масштаба газового фактора</div>
        <hr class="my-0">
      </div>
      <div class="b-map-sidebar-container">
        <div class="b-single-row-element">
          <div class="b-map-sidebar-label">Scale (m3/t)</div>
          <el-input v-model="selectedScale"/>
        </div>
        <div class="b-single-row-element">
          <div class="b-map-sidebar-label">Log</div>
          <el-checkbox v-model="isLog"/>
        </div>
        <div class="b-single-row-element">
          <div class="b-map-sidebar-label">Width scale</div>
          <el-select
            class="b-single-select"
            v-model="selectedWidthScale"
          >
            <el-option
              v-for="(value, key) in widthScales"
              :key="value"
              :label="key"
              :value="value"
            />
          </el-select>
        </div>
      </div>
    </div>
    <div class="b-map-sidebar">
      <div>
        <div class="b-map-sidebar-label b-label-bold">Панель инструментов</div>
        <hr class="my-0">
      </div>
      <div class="b-map-sidebar-container">
        <div class="b-map-sidebar-label b-label-bold">Well style</div>
        <div v-if="templateSaveAccess">
          <div class="b-map-sidebar-label">Шрифт</div>
          <div>
            <el-select
              class="b-single-select"
              v-model="wellStyle.selectedFont"
            >
              <el-option
                v-for="item in fonts"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </div>
        <div class="b-single-row-element">
          <div>Размер</div>
          <div>
            <el-input
              v-model="wellStyle.selectedFontSize"
              type="number"
              min="6"
              max="120"
            />
          </div>
        </div>
        <div
          class="b-single-row-element"
          v-if="templateSaveAccess"
        >
          <div>Цвет</div>
          <div class="row grid justify-items-center align-items-center">
            <el-color-picker
              class="col-4"
              v-model="wellStyle.selectedFontColor"
            />
          </div>
        </div>
        <div class="b-single-row-element">
          <div>wellhead name offset x, mm</div>
          <div>
            <el-input
              v-model="wellStyle.selectedDx"
              type="number"
            />
          </div>
        </div>
        <div class="b-single-row-element">
          <div>wellhead name offset y, mm</div>
          <div>
            <el-input
              v-model="wellStyle.selectedDy"
              type="number"
            />
          </div>
        </div>
        <hr class="my-0">
      </div>
      <div class="b-map-sidebar-container">
        <div class="b-map-sidebar-label b-label-bold">WaterCut style</div>
        <div v-if="templateSaveAccess">
          <div class="b-map-sidebar-label">Шрифт</div>
          <div>
            <el-select
              class="b-single-select"
              v-model="rateStyle.selectedFont"
            >
              <el-option
                v-for="item in fonts"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </div>
        <div class="b-single-row-element">
          <div>Размер</div>
          <div>
            <el-input
              v-model="rateStyle.selectedFontSize"
              type="number"
              min="6"
              max="120"
            />
          </div>
        </div>
        <div
          class="b-single-row-element"
          v-if="templateSaveAccess"
        >
          <div>wcut color</div>
          <div class="row grid justify-items-center align-items-center">
            <el-color-picker
              class="col-4"
              v-model="rateStyle.selectedFontColor"
            />
          </div>
        </div>
        <div class="b-single-row-element">
          <div>dx, mm</div>
          <div>
            <el-input
              v-model="rateStyle.selectedDx"
              type="number"
            />
          </div>
        </div>
        <div class="b-single-row-element">
          <div>dy, mm</div>
          <div>
            <el-input
              v-model="rateStyle.selectedDy"
              type="number"
            />
          </div>
        </div>
        <hr
          class="my-0"
          v-if="templateSaveAccess"
        >
      </div>
      <div
        class="b-map-sidebar-container"
        v-if="templateSaveAccess"
      >
        <div class="b-map-sidebar-label b-label-bold">Phase color</div>
        <div class="b-single-row-element">
          <div>Opacity</div>
          <div class="row grid justify-items-center align-items-center">
            <el-slider
              v-model="colorStyle.opacity"
              :min="0"
              :max="100"
            />
          </div>
        </div>
        <div class="b-single-row-element">
          <div>Oil</div>
          <div class="row grid justify-items-center align-items-center">
            <el-color-picker
              class="col-4"
              v-model="colorStyle.oil"
            />
          </div>
        </div>
        <div class="b-single-row-element">
          <div>Water</div>
          <div class="row grid justify-items-center align-items-center">
            <el-color-picker
              class="col-4"
              v-model="colorStyle.water"
            />
          </div>
        </div>
        <div class="b-single-row-element">
          <div>Stream</div>
          <div class="row grid justify-items-center align-items-center">
            <el-color-picker
              class="col-4"
              v-model="colorStyle.stream"
            />
          </div>
        </div>
        <div class="b-single-row-element">
          <div>Gas</div>
          <div class="row grid justify-items-center align-items-center">
            <el-color-picker
              class="col-4"
              v-model="colorStyle.gas"
            />
          </div>
        </div>
        <div class="b-single-row-element">
          <div>Polymer</div>
          <div class="row grid justify-items-center align-items-center">
            <el-color-picker
              class="col-4"
              v-model="colorStyle.polymer"
            />
          </div>
        </div>
        <div class="b-single-row-element">
          <div>Water injection</div>
          <div class="row grid justify-items-center align-items-center">
            <el-color-picker
              class="col-4"
              v-model="colorStyle.water_injection"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="b-map-sidebar">
      <div>
        <div class="b-map-sidebar-label b-label-bold">Settings</div>
        <hr class="my-0">
      </div>
      <div
        class="b-map-sidebar-container"
        v-if="Object.keys(this.settings.production).length > 0"
      >
        <div class="b-map-sidebar-label b-label-bold">Production circle scale</div>
        <div class="row">
          <div class="col-3 b-label-bold">Phase</div>
          <div class="col-3 b-label-bold">Dim</div>
          <div class="col-6 b-label-bold">Scale</div>
        </div>
        <div
          class="row"
          v-for="(item, index) in settings.production"
        >
          <div class="col-3 align-self-center">{{ firstLetterToUpperCase(index) }}</div>
          <div class="col-3 align-self-center">
            <!-- Временно не используется -->
            <select
              class="b-select-border-none"
              v-model="settings.production[index].dim"
            >
              <option
                v-for="(item, index) in dimValues"
                :key="item"
                :label="index"
                :value="item"
              />
            </select>
            <!-- -->
          </div>
          <div class="col-6 row align-items-center">
            <div class="col-5">
              ({{ tonsOrM3(index) }}/cm²)
            </div>
            <div class="col-7">
              <el-input
                v-model="settings.production[index].scale"
                type="number"
                min="1"
              />
            </div>
          </div>
        </div>
        <hr
          class="my-0"
          v-if="Object.keys(this.settings.injection).length > 0"
        >
      </div>
      <div
        class="b-map-sidebar-container"
        v-if="Object.keys(this.settings.injection).length > 0"
      >
        <div class="b-map-sidebar-label b-label-bold">Injection circle scale</div>
        <div class="row">
          <div class="col-3 b-label-bold">Phase</div>
          <div class="col-3 b-label-bold">Dim</div>
          <div class="col-6 b-label-bold">Scale</div>
        </div>
        <div
          class="row"
          v-for="(item, index) in settings.injection"
        >
          <div class="col-3 align-self-center">{{ firstLetterToUpperCase(index) }}</div>
          <div class="col-3 align-self-center">
            <!-- Временно не используется -->
            <select
              class="b-select-border-none"
              v-model="settings.injection[index].dim"
            >
              <option
                v-for="(item, index) in dimValues"
                :key="item"
                :label="index"
                :value="item"
              />
            </select>
            <!-- -->
          </div>
          <div class="col-6 row align-items-center">
            <div class="col-5">
              ({{ tonsOrM3(index) }}/cm²)
            </div>
            <div class="col-7">
              <el-input
                v-model="settings.injection[index].scale"
                type="number"
                min="1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="b-map-sidebar-container">
        <div>
          <el-button
            class="mb-2 b-button"
            type="button"
            v-loading.fullscreen.lock="loading"
            :disabled="!areFieldsFilledCorrect"
            @click="createSvg"
          >
            Сформировать SVG
          </el-button>
          <el-button
            class="mb-2 b-button"
            type="info"
            :disabled="!svg"
            @click="downloadSvg"
          >
            Экспортировать SVG
          </el-button>
          <el-button
            class="mb-2 b-button"
            type="success"
            v-if="templateSaveAccess"
            :disabled="!svg"
            @click="saveTemplate"
          >
            Сохранить шаблон
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ReportSideBar",
  props: {
    field: {
      type: String,
      required: true
    },
    places: {
      type: Array,
      required: true
    },
    objects: {
      type: Array,
      required: true
    },
    mapTypes: {
      type: Array,
      required: true
    },
    mapTypesWithPeriod: {
      type: Array,
      required: true
    },
    mapScales: {
      type: Array,
      required: true
    },
    widthScales: {
      type: Array,
      required: true,
    },
    mapTypesWithWidthScale: {
      type: Array,
      required: true,
    },
    mapTypesSettingsAccordance: {
      type: Array,
      required: true
    },
    fonts: {
      type: Array,
      required: true
    },
    dimValues: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      svg: null,
      loading: false,
      allField: 'Всё месторождение',
      selectedObjects: [],
      selectedMapType: Object.keys(this.mapTypes)[0],
      selectedDateFrom: moment().format('YYYY-MM'),
      selectedDateTo: moment().format('YYYY-MM'),
      selectedMapScale: Object.values(this.mapScales)[2],
      selectedScale: 600,
      isLog: false,
      selectedWidthScale: this.widthScales[0],
      wellStyle: {
        selectedFont: this.fonts[1],
        selectedFontSize: 12,
        selectedFontColor: '#000000',
        selectedDx: 1.7,
        selectedDy: -1,
      },
      rateStyle: {
        selectedFont: this.fonts[1],
        selectedFontSize: 8,
        selectedFontColor: '#0000ff',
        selectedDx: 1.7,
        selectedDy: 3,
      },
      colorStyle: {
        opacity: 100,
        oil: '#b86b41',
        water: '#67c2e5',
        stream: '#f4B084',
        gas: '#ffff00',
        polymer: '#f4B084',
        water_injection: '#0000ff',
      },
      settings: {
        production: {
          fluid: {
            dim: 1000,
            scale: 20000,
          },
        },
        injection: {
          oil: {
            dim: 1000,
            scale: 20000,
          },
          water: {
            dim: 1000,
            scale: 20000,
          },
          stream: {
            dim: 1000,
            scale: 20000,
          },
          gas: {
            dim: 1000,
            scale: 20000,
          },
          polymer: {
            dim: 1000,
            scale: 20000,
          },
        },
      },
    }
  },
  mounted() {
    if (!this.templateSaveAccess) {
      delete this.wellStyle.selectedFont;
      delete this.wellStyle.selectedFontColor;
      delete this.rateStyle.selectedFont;
      delete this.rateStyle.selectedFontColor;
      delete this.colorStyle;
    }
    this.changeMapType(this.selectedMapType);
  },
  computed: {
    areFieldsFilledCorrect() {
      const data = JSON.parse(JSON.stringify(this.$data));
      delete data.loading;
      delete data.svg;
      delete data.isLog;
      delete data.colorStyle.opacity
      let areFieldsFilled = true;
      this.traverse(data, (key, item) => {
        areFieldsFilled = areFieldsFilled && item;
      });
      return areFieldsFilled
        && this.areValuesCorrect
        && this.isDateValid;
    },
    isDateValid() {
      return this.isSecondDateRequired
        ? moment(this.selectedDateFrom, 'YYYY-MM') <= moment(this.selectedDateTo, 'YYYY-MM')
        : true;
    },
    areValuesCorrect() {
      const data = JSON.parse(JSON.stringify(this.$data));
      delete data.loading;
      delete data.svg;
      delete data.isLog;
      delete data.allField;
      delete data.selectedMapScale;
      delete data.selectedWidthScale;
      delete data.selectedObjects;
      delete data.selectedMapType;
      delete data.selectedDateFrom;
      delete data.selectedDateTo;
      delete data.wellStyle.selectedFont;
      delete data.wellStyle.selectedFontColor;
      delete data.rateStyle.selectedFont;
      delete data.rateStyle.selectedFontColor;
      delete data.colorStyle;
      let areValuesCorrect = true;
      this.traverse(data, (key, item) => {
        areValuesCorrect = areValuesCorrect && parseInt(item);
      });
      return areValuesCorrect;
    },
    isSecondDateRequired() {
      return this.mapTypesWithPeriod.includes(this.selectedMapType);
    },
    isWidthScaleRequired() {
      return this.mapTypesWithWidthScale.includes(this.selectedMapType);
    },
    templateSaveAccess() {
      return this.$page.props.user.template_save_access;
    },
  },
  methods: {
    selectObject() {
      if (this.selectedObjects[this.selectedObjects.length - 1] === this.allField) {
        this.selectedObjects = [this.allField];
      } else {
        if (this.selectedObjects.length > 1) {
          this.selectedObjects = this.selectedObjects.filter(item => item !== this.allField);
        }
      }
    },
    changeMapType(mapType) {
      // let requiredSetting;
      // this.traverse(this.mapTypesSettingsAccordance, (key, item) => {
      //   if (key === mapType) {
      //     requiredSetting = item;
      //   }
      // });
      // requiredSetting = requiredSetting.split('.');
      // Object.entries(this.settings).forEach((setting) => {
      //   delete this.settings[setting[0]][Object.keys(setting[1])[0]];
      // });
      // this.settings[requiredSetting[1]][requiredSetting[2]] = {
      //   dim: 1000,
      //   scale: 3000,
      // };
    },
    traverse(obj, callback) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === 'object' && !Array.isArray(obj[key]) && obj[key]) {
            this.traverse(obj[key], callback);
          } else {
            callback(key, obj[key]);
          }
        }
      }
    },
    firstLetterToUpperCase(label) {
      return label.charAt(0).toUpperCase() + label.slice(1);
    },
    tonsOrM3(label) {
      switch (label) {
        case 'gas':
          return 'm³';
        default:
          return 'tons';
      }
    },
    selectAllObjects() {
      this.selectedObjects = this.objects.filter(item => item !== this.allField);
    },
    createSvg() {
      this.loading = true;
      axios.post(route('reports.svg.create', this.field), this.prepareSvgData())
        .then(response => {
          this.loading = false;
          this.svg = response.data.data;
          this.$emit('svgLoaded', this.svg);
          this.$notify.success({
            title: 'Карта построена',
          });
        }).catch(error => {
        this.$notify.error({
          title: 'Ошибка',
          message: 'Не удалось сформировать карту'
            + this.parseErrors(error),
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    downloadSvg() {
      try {
        const svg = (new DOMParser())
          .parseFromString(this.svg, 'image/svg+xml')
          .documentElement
          .outerHTML;
        const blob = new Blob([svg], {type: 'image/svg+xml'});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'map.svg';
        link.click();
      } catch (e) {
        this.$notify.error({
          title: 'Ошибка',
          message: 'Не удалось скачать карту',
        });
      }
    },
    saveTemplate() {
      this.loading = true;
      let data = this.prepareSvgData();
      data.svg = this.svg;
      axios.post(route('reports.svg.store', this.field), data)
        .then(() => {
          this.loading = false;
          this.$notify.success({
            title: 'Шаблон сохранен',
          });
        }).catch(error => {
        this.$notify.error({
          title: 'Ошибка',
          message: 'Не удалось сохранить шаблон: '
            + this.parseErrors(error),
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    prepareSvgData() {
      const svgData = {
        objects: this.selectedObjects,
        map_type: this.selectedMapType,
        date_from: this.selectedDateFrom,
        map_scale: this.selectedMapScale,
        scale: this.selectedScale,
        is_log: this.isLog,
        width_scale: this.selectedWidthScale,
        well_style: {
          font: this.wellStyle.selectedFont,
          font_size: this.wellStyle.selectedFontSize,
          font_color: this.wellStyle.selectedFontColor,
          dx: this.wellStyle.selectedDx,
          dy: this.wellStyle.selectedDy,
        },
        rate_style: {
          font: this.rateStyle.selectedFont,
          font_size: this.rateStyle.selectedFontSize,
          font_color: this.rateStyle.selectedFontColor,
          dx: this.rateStyle.selectedDx,
          dy: this.rateStyle.selectedDy,
        },
        color_style: this.colorStyle,
        settings: this.settings,
      }
      if (this.isSecondDateRequired) {
        svgData.date_to = this.selectedDateTo;
      }
      return svgData;
    },
    parseErrors(error) {
      let err_msg = '';
      if (error.response?.data?.errors) {
        err_msg = ': ' + Object.values(error.response.data.errors).join(' ');
      }
      return err_msg;
    }
  }
}
</script>
